<ion-header>
    <ion-toolbar>
        <ion-title>{{ 'Select team matches' | translate }}</ion-title>
        <ion-buttons slot="end">
            <app-close-button></app-close-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list class="content-width">
        @for (tie of ties; let i = $index; track i) {
            <ion-item>
                <ion-checkbox color="secondary" labelPlacement="end" justify="start" (ionChange)="selectTie($event, i)">
                    <div>
                        {{ getTeamName(tie, 1) }} - {{ getTeamName(tie, 2) }}
                        <p style="font-size: 13px; color: gray; margin: 0px;">{{ tie.startDate | date: 'EEEE, MMMM d, y, h:mm a' }}</p>
                    </div>
                </ion-checkbox>
            </ion-item>
        }
    </ion-list>

    @if (getMoreTies) {
        <ion-infinite-scroll (ionInfinite)="doInfinite($event)">
            <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Load more data...">
            </ion-infinite-scroll-content>
        </ion-infinite-scroll>
    }

    @for (item of [0, 1, 2, 3, 4]; track $index) {
        <div [hidden]="!isLoading" class="content-width ion-margin">
            <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
        </div>
    }

</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button [disabled]="!selectedTies.length" class="ion-margin-start ion-margin-end" (click)="selectTies()" expand="block" fill="solid">
            {{ 'Select ties' | translate }}            
        </ion-button>
    </ion-toolbar>
</ion-footer>